// Everything the original bugPicker.ts hard-coded for the résumé site becomes host-app config
// here: component naming, version string, route sanitization, app chrome the picker must ignore,
// and theme. Extracted from interactive-resume-suite packages/website/src/lib/bugPicker.ts @033a918.

export interface RedSdkTheme {
  accent: string;
  ink: string;
  card: string;
}

export interface RedSdkConfig {
  /** Target app identity, stamped into every captured context. */
  app: { name: string; version: string };
  /** Shell origins allowed to drive this SDK over postMessage. Origin-pinned both directions. */
  allowedParents: string[];
  /**
   * Component naming for captured elements: an ancestor attribute always wins (default `data-c`),
   * else the first matching class prefix names the component. Empty by default — the résumé's
   * prefix map was app-specific and stays in that app's config.
   */
  componentAttr?: string;
  componentPrefixes?: readonly (readonly [string, string])[];
  /** Query params stripped from the captured route (magic-link tokens, session ids, …). */
  stripParams?: readonly string[];
  /** Selectors for the host app's own chrome that the picker must neither pick nor suppress. */
  ignoreSelectors?: readonly string[];
  theme?: Partial<RedSdkTheme>;
}

export interface ResolvedConfig extends Required<Omit<RedSdkConfig, "theme">> {
  theme: RedSdkTheme;
}

export function resolveConfig(cfg: RedSdkConfig): ResolvedConfig {
  if (!cfg.app?.name || !cfg.app?.version) throw new Error("red-sdk: app.name and app.version are required");
  if (!cfg.allowedParents?.length) throw new Error("red-sdk: allowedParents must list at least one shell origin");
  return {
    app: cfg.app,
    allowedParents: cfg.allowedParents,
    componentAttr: cfg.componentAttr ?? "data-c",
    componentPrefixes: cfg.componentPrefixes ?? [],
    stripParams: cfg.stripParams ?? [],
    ignoreSelectors: cfg.ignoreSelectors ?? [],
    theme: {
      accent: cfg.theme?.accent ?? "#e24b4a",
      ink: cfg.theme?.ink ?? "#1d222b",
      card: cfg.theme?.card ?? "#ffffff",
    },
  };
}
